/**
 * Cart drawer: size-matched recommendations (2026-10).
 *
 * Replaces the products of the existing upsell carousel (snippets/cart-drawer.liquid,
 * fixed collection = Theme settings › Cart › cart_drawer_collection, today NWCP):
 *
 *   1. a full-price shoe in the cart (Liquid sets data-nc-fullprice-shoe="true" on
 *      .cart-drawer__upsells) → no discounted shoes next to it: NWCP only, socks first,
 *      then the other NWCP cards ordered by the free-shipping gap
 *   2. discounted shoes → Últimas tallas shoes in stock in the cart size ("Disponible en tu
 *      talla 41"). Free shipping unlocked / not offered: biggest discount first; otherwise
 *      the ones whose price alone closes the gap first (cheapest first), then by discount;
 *      gap ≤ SMALL_GAP_EUR: same list, title "Para llegar al envío gratis".
 *      Fewer than MIN_MATCH matches → NWCP, socks first.
 *   3. clothing only → broken-size clothing (letter sizes; at most 2 sizes left, or half of
 *      them or fewer; not NWCP) in stock in the cart size, same ordering as 2.
 *      Fewer than MIN_MATCH matches → NWCP, socks first.
 *   4. anything else → NWCP, socks first.
 * NWCP is otherwise paused (2026-10): no NWCP cards next to the size-matched products.
 *
 * "+" on a card that knows the customer's size (data-preselect, in stock) adds that size
 * straight to the cart; tapping the card itself still opens the size panel.
 *
 * Data: /collections/<handle>?view=size-recs (templates/collection.size-recs.liquid) for
 * ultimas-tallas (shoes), all-streetwear (clothing, in stock) and nwcp (socks), cached
 * 10 min in sessionStorage per locale/currency. Cart sizes: /cart.js.
 * Size groups = assets/my-size.js SIZE_GROUPS (keep in sync).
 * The new cards use the same markup as the Liquid ones, so assets/cart-drawer-inline.js
 * binds the size panel and the add-to-cart to them as usual.
 */
(function () {
  'use strict';

  var SMALL_GAP_EUR = 3000; // cents
  var MIN_MATCH = 2;
  var MAX_SLIDES = 10;
  var CACHE_MS = 10 * 60 * 1000;
  var COLLECTION = 'ultimas-tallas';          // broken-size shoes
  var CLOTHING_COLLECTION = 'all-streetwear'; // all clothing (type contains "clothing")
  var FIXED_COLLECTION = 'nwcp';              // = settings.cart_drawer_collection
  var LETTER_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var EXCLUDE_VENDOR = /^(newcop|nwcp)$/i;    // NWCP paused: not among the broken-size clothing
  // socks, by (translated) product title in the 13 storefront languages
  var SOCK_RE = /calcet|sock|chausset|calzin|meias|skarpet|mitjon|sokken|κάλτσ|čarap|carap|șoset|sosete|strømpe|strompe/i;

  var T = {
    es: ['Disponible en tu talla __SIZE__', 'Para llegar al envío gratis', 'Agotado'],
    en: ['Available in your size __SIZE__', 'To reach free shipping', 'Sold out'],
    fr: ['Disponible dans votre taille __SIZE__', 'Pour atteindre la livraison offerte', 'Épuisé'],
    de: ['In deiner Größe __SIZE__ verfügbar', 'Für kostenlosen Versand', 'Ausverkauft'],
    it: ['Disponibile nella tua taglia __SIZE__', 'Per arrivare alla spedizione gratuita', 'Esaurito'],
    pt: ['Disponível no seu tamanho __SIZE__', 'Para chegar ao envio grátis', 'Esgotado'],
    pl: ['Dostępne w Twoim rozmiarze __SIZE__', 'Do darmowej dostawy', 'Wyprzedane'],
    ca: ['Disponible a la teva talla __SIZE__', "Per arribar a l'enviament gratuït", 'Esgotat'],
    nl: ['Beschikbaar in jouw maat __SIZE__', 'Voor gratis verzending', 'Uitverkocht'],
    el: ['Διαθέσιμο στο μέγεθός σου __SIZE__', 'Για δωρεάν αποστολή', 'Εξαντλήθηκε'],
    hr: ['Dostupno u tvojoj veličini __SIZE__', 'Do besplatne dostave', 'Rasprodano'],
    ro: ['Disponibil în mărimea ta __SIZE__', 'Pentru livrare gratuită', 'Epuizat'],
    da: ['Fås i din størrelse __SIZE__', 'Til fri fragt', 'Udsolgt']
  };
  function strings() {
    var lang = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    return T[lang] || T.es;
  }

  // ---- sizes (same table and normaliser as assets/my-size.js) ----
  function norm(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/\s*eu$/, '').replace(',', '.')
      .replace(/\s*1\/3/, '.33').replace('⅓', '.33')
      .replace(/\s*2\/3/, '.67').replace('⅔', '.67')
      .replace('½', '.5')
      .replace(/\.3$/, '.33').replace(/\.6$/, '.67')
      .replace(/\.0$/, '');
  }
  var SIZE_GROUPS = {
    '36.5': '36.5', '36.67': '36.5',
    '37': '37.5', '37.33': '37.5', '37.5': '37.5', '37.67': '37.5',
    '38': '38', '38.5': '38.5', '38.67': '38.5',
    '39': '39', '39.33': '39',
    '40.5': '40.5', '40.67': '40.5',
    '41': '41', '41.33': '41', '41.5': '41',
    '42.5': '42.5', '42.67': '42.5',
    '43': '43', '43.33': '43', '43.5': '43',
    '44.5': '44.5', '44.67': '44.5',
    '45.33': '45.5', '45.5': '45.5',
    '46.5': '46.5', '46.67': '46.5',
    '47.33': '47.5', '47.5': '47.5'
  };
  function keyOf(s) { var k = norm(s); return SIZE_GROUPS[k] || k; }
  function isShoeSize(s) { return /^\d+(\.\d+)?$/.test(norm(s)); }
  function sizeToken(s) { return String(s || '').split('-')[0].trim().split(' ')[0]; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function centsOf(el) {
    var t = el ? (el.getAttribute('data-price') || '') : '';
    var m = t.replace(/[^\d.,]/g, '');
    if (!m) return Infinity;
    var dec = /[.,]\d{2}$/.test(m);
    var digits = parseInt(m.replace(/[^\d]/g, ''), 10);
    return isNaN(digits) ? Infinity : (dec ? digits : digits * 100);
  }
  function discount(p) { return p.cp > p.p ? (p.cp - p.p) / p.cp : 0; }

  // ---- data ----
  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }
  function loadRecs(handle, extra) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var url = rootUrl() + '/collections/' + handle + '?view=size-recs' + (extra || '');
    var key = 'ncCartRecs:' + url + ':' + cur;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < CACHE_MS) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var d = JSON.parse(txt.trim()).products || [];
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      });
  }
  function loadCart() {
    var base = (window.routes && window.routes.cart_url) || rootUrl() + '/cart';
    return fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // threshold / gap in cart-currency cents; threshold 0 = no free shipping here
  function shippingGap() {
    var bar = document.querySelector('#CartDrawer .cart-drawer__free-shipping');
    var subEl = document.getElementById('cartsubTotal');
    var sub = subEl && /^\d+$/.test(subEl.getAttribute('data-cents') || '') ? parseInt(subEl.getAttribute('data-cents'), 10) : null;
    if (!bar || sub === null) return { threshold: 0, gap: 0, rate: 1 };
    var eur = parseInt(bar.getAttribute('data-free-shipping-threshold'), 10) || 0;
    var rate = 1;
    if (bar.hasAttribute('data-nc-fs-convert')) {
      var c = window.Shopify && Shopify.currency;
      rate = c ? parseFloat(c.rate) : NaN;
      if (!c || c.active !== bar.getAttribute('data-nc-fs-currency') || !isFinite(rate) || rate <= 0) {
        return { threshold: 0, gap: 0, rate: 1 };
      }
    }
    var threshold = Math.ceil(eur * rate);
    return { threshold: threshold, gap: threshold - sub, rate: rate };
  }

  // ---- markup (same structure as the Liquid cards in snippets/cart-drawer.liquid) ----
  function slideHtml(p, group, labels) {
    var pre = '';
    var single = (p.z || []).length === 1;
    if (single && p.z[0][2]) pre = String(p.z[0][1]);
    var sizes = (p.z || []).map(function (v) {
      var ok = !!v[2];
      if (ok && !pre && keyOf(v[0]) === group) pre = String(v[1]);
      return '<button type="button" class="cart-drawer__upsells-size' + (ok ? '' : ' is-soldout') + '"' +
        ' data-variant-id="' + esc(v[1]) + '" data-price="' + esc(p.pf) + '"' + (ok ? '' : ' disabled') +
        ' aria-label="' + esc(p.t + ' — ' + v[0] + (ok ? '' : ' (' + labels.soldOut + ')')) + '">' + esc(sizeToken(v[0])) + '</button>';
    }).join('');
    var firstOk = (p.z || []).filter(function (v) { return v[2]; })[0];
    var pct = p.cp > p.p ? Math.round((p.cp - p.p) * 100 / p.cp) : 0;
    var disc = pct > 0 ? saveHtml(labels.save, p.cp, p.p) || '-' + pct + '%' : '';
    return '<div class="cart-drawer__upsells-slide" data-nc-size-rec>' +
      '<div class="cart-drawer__upsells-link" data-product-id="h-' + esc(p.h) + '" data-variant-id="' + esc(pre || (firstOk ? firstOk[1] : '')) + '"' +
      ' data-preselect="' + esc(pre) + '" data-title="' + esc(p.t) + '" data-price="' + esc(p.pf) + '">' +
      '<div class="cart-drawer__upsells-image-wrapper">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" class="cart-drawer__upsells-image cart-drawer__upsells-image--primary" loading="lazy" width="148" height="148">' : '') +
      '<button type="button" class="cart-drawer__upsells-plus" aria-label="' + esc(labels.add + ': ' + p.t) + '" aria-expanded="false">' +
      '<svg width="11" height="11" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 6H11" stroke="currentColor" stroke-width="1.4"/><path class="cart-drawer__upsells-plus-v" d="M6 1V11" stroke="currentColor" stroke-width="1.4"/></svg>' +
      '</button>' +
      '<div class="cart-drawer__upsells-sizes"' + (single ? '' : ' data-multi="true"') + '><span class="cart-drawer__upsells-sizes-label">' + esc(labels.add) + '</span>' +
      '<div class="cart-drawer__upsells-sizes-list">' + sizes + '</div></div>' +
      '</div>' +
      '<div class="cart-drawer__upsells-info"><p class="cart-drawer__upsells-product-title">' + esc(p.t) + '</p>' +
      '<div class="cart-drawer__upsells-price-wrapper"><div class="cart-drawer__upsells-price" data-product-id="h-' + esc(p.h) + '">' + esc(p.pf) + '</div>' +
      (pct > 0 ? '<s class="cart-drawer__upsells-compare-price">' + esc(p.cf) + '</s><span class="cart-drawer__upsells-discount">' + disc + '</span>' : '') +
      '</div></div></div></div>';
  }

  // the cards that close the free-shipping gap on their own first (cheapest first), then the
  // rest closest to the gap first (most expensive of those first)
  function byGap(gap) {
    return function (a, b) {
      var ca = a.p >= gap, cb = b.p >= gap;
      if (ca !== cb) return ca ? -1 : 1;
      return ca ? a.p - b.p : b.p - a.p;
    };
  }

  // ---- fixed (NWCP) fallback: socks first ----
  function isSock(title) { return SOCK_RE.test(title || ''); }

  // NWCP cards: socks first (built from the NWCP data, so they show even when Liquid filtered
  // the carousel by a clothing size), then the other Liquid cards ordered by the free-shipping
  // gap. Used for a full-price shoe, too few size matches, and carts without shoes/clothing.
  function applyFixed(root, state, inCart) {
    var track = root.querySelector('#upsells-track') || root.querySelector('.cart-drawer__upsells-track');
    if (!track) { root.setAttribute('data-nc-size-recs', state); return Promise.resolve(); }
    var ship = shippingGap();
    var labels = labelsOf(root);
    return loadRecs(FIXED_COLLECTION, '').catch(function () { return []; }).then(function (fixed) {
      if (!document.body.contains(root)) return;
      var socks = (fixed || []).filter(function (p) {
        return isSock(p.t) && !(inCart && inCart[p.h]) && (p.z || []).some(function (v) { return v[2]; });
      }).sort(function (a, b) { return a.p - b.p; });
      var others = Array.prototype.slice.call(track.children).filter(function (el) {
        var card = el.querySelector('.cart-drawer__upsells-link');
        return !(socks.length && card && isSock(card.getAttribute('data-title')));
      }).map(function (el) {
        return { el: el, p: centsOf(el.querySelector('.cart-drawer__upsells-link')) };
      });
      if (ship.threshold > 0 && ship.gap > 0) others.sort(byGap(ship.gap));
      var panel = root.querySelector('.cart-drawer__upsells-panel');
      if (panel) { panel.hidden = true; panel.removeAttribute('data-product-id'); }
      track.innerHTML = '';
      track.insertAdjacentHTML('beforeend', socks.map(function (p) { return slideHtml(p, '', labels); }).join(''));
      others.slice(0, Math.max(0, MAX_SLIDES - socks.length)).forEach(function (x) { track.appendChild(x.el); });
      var carousel = track.closest('.cart-drawer__upsells-carousel');
      if (carousel) carousel.scrollLeft = 0;
      // keep Liquid's "in your size" title when it matched a clothing size from the cart;
      // otherwise "to reach free shipping" while there is a gap
      var titleEl = root.querySelector('.cart-drawer__upsells-title');
      var liquidInSize = !!track.querySelector('.cart-drawer__upsells-link[data-preselect]:not([data-preselect=""]):not([data-product-id^="h-"])');
      if (titleEl && !liquidInSize && ship.threshold > 0 && ship.gap > 0) titleEl.textContent = strings()[1];
      if (track.children.length) root.style.display = '';
      root.setAttribute('data-nc-size-recs', state);
      labelPlus(root);
      if (typeof window.reinitUpsells === 'function') window.reinitUpsells();
    });
  }

  function labelsOf(root) {
    var panel = root.querySelector('.cart-drawer__upsells-panel');
    var sample = root.querySelector('.cart-drawer__upsells-sizes-label');
    return {
      add: (panel && panel.getAttribute('data-text-add')) || (sample ? sample.textContent.trim() : '+'),
      soldOut: strings()[2],
      save: saveCfg(root)
    };
  }

  // ---- "Ahorras X €" (2026-10, Theme settings › Ahorro en euros) ----
  // snippets/cart-drawer.liquid renders data-nc-save-* on .cart-drawer__upsells only when
  // the switch is on and the visitor pays in the shop currency (EUR): threshold in cents,
  // translated "Ahorras {amount}" and money_without_trailing_zeros of 1234.56 ("1,234.56€").
  function saveCfg(root) {
    var tpl = root && root.getAttribute('data-nc-save-tpl');
    if (!tpl) return null;
    var min = parseInt(root.getAttribute('data-nc-save-min'), 10);
    var m = /^([^0-9]*)1([^0-9]?)234(?:([^0-9])56)?([^0-9]*)$/.exec(String(root.getAttribute('data-nc-save-fmt') || '').trim());
    if (!isFinite(min) || !m) return null;
    return { min: min, tpl: tpl, m: m };
  }
  function saveMoney(cfg, cents) {
    var m = cfg.m;
    var whole = String(Math.floor(cents / 100));
    if (m[2]) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
    var rest = cents % 100;
    return m[1] + whole + (m[3] && rest ? m[3] + (rest < 10 ? '0' : '') + rest : '') + m[4];
  }
  // same markup as the Liquid cards: the label words stay together, the amount on one line
  function saveHtml(cfg, strike, price) {
    if (!cfg || !(strike > price) || strike < cfg.min) return '';
    var parts = cfg.tpl.split('{amount}');
    var pre = esc(parts[0].replace(/\s+$/, '')).replace(/ /g, '&nbsp;');
    return pre + ' <span style="white-space: nowrap;">' + esc(saveMoney(cfg, Math.round(strike - price))) + '</span>' + esc(parts.slice(1).join(''));
  }

  // "+" says which size it adds (screen readers): "Añadir 42: <product>"
  function labelPlus(root) {
    root.querySelectorAll('.cart-drawer__upsells-link[data-preselect]').forEach(function (card) {
      var pre = card.getAttribute('data-preselect');
      var plus = card.querySelector('.cart-drawer__upsells-plus');
      if (!pre || !plus || plus.hasAttribute('data-nc-labelled')) return;
      var btn = card.querySelector('.cart-drawer__upsells-size[data-variant-id="' + pre + '"]');
      if (!btn || btn.disabled) return;
      var lbl = plus.getAttribute('aria-label') || '';
      var i = lbl.indexOf(':');
      if (i > 0 && card.querySelectorAll('.cart-drawer__upsells-size').length > 1) {
        plus.setAttribute('aria-label', lbl.slice(0, i) + ' ' + btn.textContent.trim() + lbl.slice(i));
      }
      plus.setAttribute('data-nc-labelled', '');
    });
  }

  // the cart size (shoe or clothing) with the most matching products
  function bestSize(sizes, recs, inCart, extra) {
    var best = null;
    sizes.forEach(function (sz) {
      var g = keyOf(sz);
      var list = recs.filter(function (p) {
        return !inCart[p.h] && (!extra || extra(p)) &&
          (p.z || []).some(function (v) { return v[2] && keyOf(v[0]) === g; });
      });
      if (!best || list.length > best.list.length) best = { size: sz, group: g, list: list };
    });
    return best;
  }

  // broken-size clothing: letter sizes, at most 2 sizes left or half of them or fewer, not NWCP
  function isLetter(s) { return LETTER_SIZES.indexOf(String(s || '').trim().toUpperCase()) !== -1; }
  function brokenClothing(p) {
    var z = p.z || [];
    if (z.length < 2 || EXCLUDE_VENDOR.test(p.v || '')) return false;
    if (!z.every(function (v) { return isLetter(v[0]); })) return false;
    var a = z.filter(function (v) { return v[2]; }).length;
    return a > 0 && (a <= 2 || a / z.length <= 0.5);
  }

  function render(root, list, group, titleText, state) {
    var track = root.querySelector('#upsells-track') || root.querySelector('.cart-drawer__upsells-track');
    if (!track) return;
    var labels = labelsOf(root);
    var panel = root.querySelector('.cart-drawer__upsells-panel');
    if (panel) { panel.hidden = true; panel.removeAttribute('data-product-id'); }
    track.innerHTML = list.slice(0, MAX_SLIDES).map(function (p) { return slideHtml(p, group, labels); }).join('');
    var carousel = track.closest('.cart-drawer__upsells-carousel');
    if (carousel) carousel.scrollLeft = 0;
    var titleEl = root.querySelector('.cart-drawer__upsells-title');
    if (titleEl) titleEl.textContent = titleText;
    root.style.display = '';
    root.setAttribute('data-nc-size-recs', state);
    labelPlus(root);
    if (typeof window.reinitUpsells === 'function') window.reinitUpsells();
  }

  // sort by the free-shipping situation: unlocked / none → biggest discount first;
  // gap → the ones whose price alone closes it first (cheapest first), then by discount
  function sortForGap(list, ship) {
    if (ship.threshold <= 0 || ship.gap <= 0) {
      return list.sort(function (a, b) { return discount(b) - discount(a) || a.p - b.p; });
    }
    return list.sort(function (a, b) {
      var ca = a.p >= ship.gap, cb = b.p >= ship.gap;
      if (ca !== cb) return ca ? -1 : 1;
      if (ca) return a.p - b.p;
      return discount(b) - discount(a) || b.p - a.p;
    });
  }

  // ---- main ----
  var running = false;
  function apply() {
    var root = document.querySelector('#CartDrawer .cart-drawer__upsells');
    if (!root) return;
    labelPlus(root);
    if (root.hasAttribute('data-nc-size-recs') || running) return;
    root.setAttribute('data-nc-size-recs', 'pending');
    running = true;
    var shoeSizes = [], clothSizes = [], inCart = {};
    var done = function () { running = false; };
    loadCart().then(function (cart) {
      (cart.items || []).forEach(function (it) {
        inCart[it.handle] = true;
        var sz = (it.variant_options || [])[0] || it.variant_title || '';
        var type = it.product_type || '';
        if (/sneaker|zapat|calzado/i.test(type) && isShoeSize(sz)) shoeSizes.push(sz);
        else if (isLetter(sz)) clothSizes.push(String(sz).trim().toUpperCase());
      });
      if (!document.body.contains(root)) { done(); return apply(); } // drawer re-rendered meanwhile
      var str = strings();
      var ship = shippingGap();

      // 1. a full-price shoe in the cart: no discounted shoes next to it, NWCP (socks first)
      if (root.getAttribute('data-nc-fullprice-shoe') === 'true') {
        return applyFixed(root, 'fullprice', inCart).then(done);
      }

      // 2. discounted shoes: Últimas tallas shoes in the cart size
      if (shoeSizes.length) {
        return loadRecs(COLLECTION, '').then(function (recs) {
          done();
          if (!document.body.contains(root)) return apply();
          var best = bestSize(shoeSizes, recs, inCart);
          if (!best || best.list.length < MIN_MATCH) return applyFixed(root, 'few', inCart);
          var small = ship.threshold > 0 && ship.gap > 0 && ship.gap <= Math.ceil(SMALL_GAP_EUR * ship.rate);
          render(root, sortForGap(best.list.slice(), ship), best.group,
            small ? str[1] : str[0].replace('__SIZE__', best.size),
            ship.threshold <= 0 || ship.gap <= 0 ? 'insize' : (small ? 'small' : 'big'));
        });
      }

      // 4. anything else (accessories…): NWCP, socks first
      return applyFixed(root, 'other', inCart).then(done);
    }).catch(function (e) {
      running = false;
      root.setAttribute('data-nc-size-recs', 'error');
      if (window.console) console.warn('nc-cart-size-recs:', e);
    });
  }

  // "+" with a known, in-stock size → add that size directly. Runs in the capture phase,
  // before the card's own handler (which would open the size panel); the hidden size
  // button's click handler in cart-drawer-inline.js does the add-to-cart and the refresh.
  function onPlusClick(e) {
    var plus = e.target && e.target.closest ? e.target.closest('#CartDrawer .cart-drawer__upsells-plus') : null;
    if (!plus) return;
    var card = plus.closest('.cart-drawer__upsells-link');
    var pre = card && card.getAttribute('data-preselect');
    if (!pre) return;
    var carousel = card.closest('.cart-drawer__upsells-carousel');
    if (carousel && carousel.classList.contains('dragging')) return;
    var btn = card.querySelector('.cart-drawer__upsells-size[data-variant-id="' + pre + '"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (card.classList.contains('adding')) return;
    btn.click();
  }

  function addStyles() {
    if (document.getElementById('nc-cart-size-recs-css')) return;
    var s = document.createElement('style');
    s.id = 'nc-cart-size-recs-css';
    s.textContent =
      '#CartDrawer .cart-drawer__upsells-link.adding .cart-drawer__upsells-plus{pointer-events:none}' +
      '#CartDrawer .cart-drawer__upsells-link.adding .cart-drawer__upsells-plus svg{animation:ncCartSpin .7s linear infinite}' +
      '@keyframes ncCartSpin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){#CartDrawer .cart-drawer__upsells-link.adding .cart-drawer__upsells-plus svg{animation:none;opacity:.4}}';
    document.head.appendChild(s);
  }

  function init() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    addStyles();
    document.addEventListener('click', onPlusClick, true);
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 120);
    }).observe(drawer, { childList: true, subtree: true });
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
